function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Group_3199",
  "data-name": "Group 3199",
  transform: "translate(-751.761 -1875.598)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Exclusion_1",
  "data-name": "Exclusion 1",
  d: "M31.274,25.586H0V0H31.274V25.586ZM4.087,15.532V20.1h23.73V15.532Zm0-9.126v4.562h23.73V6.406Z",
  transform: "translate(751.761 1882.705)",
  fill: "#f03f1d"
}), /*#__PURE__*/React.createElement("path", {
  id: "XMLID_3056_",
  d: "M360,120h14.215v25.587H360Z",
  transform: "translate(425.878 1762.705)",
  fill: "#f03f1d"
}), /*#__PURE__*/React.createElement("path", {
  id: "XMLID_3055_",
  d: "M292.108,47.843h4.264V45H285v2.843h4.264v4.264h2.843Z",
  transform: "translate(493.771 1830.598)",
  fill: "#f03f1d"
}), /*#__PURE__*/React.createElement("path", {
  id: "XMLID_3054_",
  d: "M289.265,390v4.265H285v2.843h11.372v-2.843h-4.264V390Z",
  transform: "translate(493.771 1518.292)",
  fill: "#f03f1d"
}));

var SvgPayWithNumber = function SvgPayWithNumber(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48.332,
    height: 39.802,
    viewBox: "0 0 48.332 39.802",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPayWithNumber, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/PayWithNumber.ef254aff.svg";
export { ForwardRef as ReactComponent };